function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4C0 3.44772 0.447715 3 1 3H13C13.5523 3 14 3.44772 14 4V5H16.882C17.2607 5 17.607 5.214 17.7764 5.55279L19.8944 9.78885C19.9639 9.92771 20 10.0808 20 10.2361V14C20 14.5523 19.5523 15 19 15H18.9646C18.7219 16.6961 17.2632 18 15.5 18C13.7368 18 12.2781 16.6961 12.0354 15H8.96456C8.72194 16.6961 7.26324 18 5.5 18C3.73676 18 2.27806 16.6961 2.03544 15H1C0.447716 15 0 14.5523 0 14V4ZM18 10L16.6667 7H14V10H18ZM15.5 16.25C16.4665 16.25 17.25 15.4665 17.25 14.5C17.25 13.5335 16.4665 12.75 15.5 12.75C14.5335 12.75 13.75 13.5335 13.75 14.5C13.75 15.4665 14.5335 16.25 15.5 16.25ZM7.25 14.5C7.25 15.4665 6.4665 16.25 5.5 16.25C4.5335 16.25 3.75 15.4665 3.75 14.5C3.75 13.5335 4.5335 12.75 5.5 12.75C6.4665 12.75 7.25 13.5335 7.25 14.5Z",
  fill: "currentColor"
});

var SvgVehicle = function SvgVehicle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle.5b855f35.svg";
export { ForwardRef as ReactComponent };